module.exports = __webpack_public_path__ + "img/PCAD_Prepurchased option_Website.48594081.jpg";